import { Phone, Mail, MapPin, Clock } from 'lucide-react'
import { business } from '../../config/business'
import { trackEvent } from '../../lib/gtag'

const NAV_LINKS = [
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Service Areas', href: '#service-areas' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#contact' },
]

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-ink-300">
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand column */}
          <div>
            <div className="flex flex-col leading-none mb-4">
              <span className="font-heading font-extrabold text-white text-2xl tracking-tight">Fateh</span>
              <span className="font-heading font-medium text-accent-400 text-xs tracking-widest uppercase">
                Heating &amp; Cooling
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-4">
              Serving London, St. Thomas, Strathroy &amp; Woodstock with professional HVAC installation and repair.
            </p>
            <p className="text-xs text-ink-400">TSSA Authorized · G2 Licensed · ODP Certified</p>
          </div>

          {/* Contact column */}
          <div>
            <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider mb-5">
              Contact
            </h3>
            <div className="space-y-3 text-sm">
              <a
                href={`tel:${business.phone}`}
                onClick={() => trackEvent('phone_call_click', { method: 'tel_link' })}
                className="flex items-center gap-3 hover:text-white transition-colors duration-200"
              >
                <Phone size={15} className="text-accent-400 shrink-0" />
                {business.phoneDisplay}
              </a>
              <a
                href={`mailto:${business.email}`}
                className="flex items-center gap-3 hover:text-white transition-colors duration-200 break-all"
              >
                <Mail size={15} className="text-accent-400 shrink-0" />
                {business.email}
              </a>
              <div className="flex items-start gap-3">
                <MapPin size={15} className="text-accent-400 shrink-0 mt-0.5" />
                <span>{business.address.full}</span>
              </div>
              <div className="flex items-center gap-3">
                <Clock size={15} className="text-success-500 shrink-0" />
                <span className="text-success-500 font-medium">Open 24 Hours</span>
              </div>
            </div>
          </div>

          {/* Quick links column */}
          <div>
            <h3 className="font-heading font-semibold text-white text-sm uppercase tracking-wider mb-5">
              Quick Links
            </h3>
            <div className="flex flex-col gap-2 text-sm">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="hover:text-white transition-colors duration-200 w-fit"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-navy-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ink-400">
          <p>
            © 2026 Fateh Heating and Cooling. All rights reserved.{' '}
            <a href="/privacy" className="underline underline-offset-2 hover:text-white">
              Privacy Policy
            </a>
          </p>
          <p>
            Website by{' '}
            <a
              href="https://www.mtrxstudio.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent-400 hover:text-accent-500 transition-colors duration-200"
            >
              MTRX Studio
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
